// extracted by mini-css-extract-plugin
export default {"nav":"Overview_nav__E0Nhv","item":"Overview_item__OsV7r","active":"Overview_active__L1kgF","progress":"Overview_progress__mva-P"};